module.exports = __webpack_public_path__ + "img/Red.77384be3.svg";